<template>
    <div class="px-8">
        <form-header title="Reports">
        </form-header>

        <div class="pt-4 grid grid-cols-2 sm:grid-cols-4 xl:grid-cols-6 gap-3">
            <div v-for="(report, idx) in reports" :key="idx" 
                @click="onClickReport(report, idx)"
                :class="report.style"
                class="shadow-md rounded-lg h-32 p-3 text-white relative
                        transition ease-in-out duration-150
                        transform hover:scale-105 hover:shadow-xl">
                <div class="text-sm font-bold uppercase">{{report.name}}</div>
                <DownloadIcon v-if="loadingReport != idx" class="flex-shrink-0 mr-1.5 h-5 w-5 text-white absolute right-2 bottom-3" aria-hidden="true" />
                <img v-if="loadingReport == idx" class="flex-shrink-0 mr-1.5 h-5 w-5 text-white absolute right-2 bottom-3" src="@/assets/loading-spinner.svg">
            </div>
        </div>

    </div>
</template>

<script>
import FormHeader from '../components/FormHeader.vue'
import { DownloadIcon } from '@heroicons/vue/outline'
import FileSaver from 'file-saver'

export default {
    components: { FormHeader, DownloadIcon },
    data: function() {
        return {
            loadingReport: -1,
            reports: [
                { style: 'bg-gradient-to-br from-red-400 to-purple-600', name: 'Devices', href:'/report/devices' },
                { style: 'bg-gradient-to-br from-purple-400 to-blue-800', name: 'Installers', href:'/report/installer' },
                { style: 'bg-gradient-to-br from-blue-500 to-green-300', name: 'Registrations', href:'/report/registrations' },
                { style: 'bg-gradient-to-br from-blue-600 to-gray-300', name: 'Mi Points', href:'/report/miPoints' },
                { style: 'bg-gradient-to-br from-green-500 to-yellow-300', name: 'Parts', href:'/report/parts', fileName: 'parts.xlsx' },
                { style: 'bg-gradient-to-br from-yellow-400 to-red-500', name: 'MiPro Companies', href:'/report/miProCompanies', fileName: 'mipro-companies.xlsx' },
                { style: 'bg-gradient-to-br from-indigo-500 to-purple-800', name: 'Company Training', href:'/report/companyTraining', fileName: 'company-training.xlsx' },
            ]
        }
    },
    props: [
        'id',
    ],
    methods: {
        onClickReport: async function(report, idx) {
            if (this.loadingReport != -1) { return }
            this.loadingReport = idx
            const ret = await this.axios.get(report.href, { responseType: 'arraybuffer' })
            FileSaver.saveAs(new Blob([ret.data], {type:ret.headers['content-type']}), report.fileName || 'report.xlsx')
            this.loadingReport = -1
        }
    }
}
</script>